import { WebStorageStateStore } from 'oidc-client-ts';

import { configureTokenProvider } from '@/shared/api';
import { appConfig } from '@/shared/config';
import type { RuntimeConfig } from '@/shared/config';

import type { AuthProviderProps } from 'react-oidc-context';

export function createOidcConfig(config: RuntimeConfig): AuthProviderProps {
  configureTokenProvider({ authority: config.authAuthority, clientId: config.authClientId });

  return {
    authority: config.authAuthority,
    client_id: config.authClientId,
    scope: 'openid profile',
    redirect_uri: window.location.origin + window.location.pathname,
    post_logout_redirect_uri: window.location.origin,
    staleStateAgeInSeconds: appConfig.auth.staleStateAgeInSeconds,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: appConfig.auth.automaticSilentRenew,
    onSigninCallback: () => {
      window.history.replaceState({}, '', window.location.pathname);
    },
  };
}
